import { useFormContext } from 'react-hook-form';
import { useEffect } from 'react';
import { useHoaDonMuaHangTrongNuocSearchContext } from '../../context';
import { FormFieldV2 } from '@/components/custom/erp';
import { Label } from '@/components/ui/label';
import { FormMode } from '@/types/form';

export function OtherTab({ formMode }: { formMode: FormMode }) {
  const { transactionOptions } = useHoaDonMuaHangTrongNuocSearchContext();
  const { watch, setValue } = useFormContext();
  const maGD = watch('ma_gd');
  const isViewMode = formMode === 'view';

  useEffect(() => {
    if (maGD || !transactionOptions?.length) return;

    setValue('ma_gd', transactionOptions[0]?.value, {
      shouldDirty: false,
      shouldTouch: false,
      shouldValidate: true
    });
  }, [maGD, setValue, transactionOptions]);

  return (
    <div className='space-y-2 p-3 xl:p-4'>
      <div className='flex items-center gap-3'>
        <Label className='w-32 shrink-0 text-[13px] xl:w-40'>Giao dịch</Label>
        <div className='w-[237px]'>
          <FormFieldV2
            disabled={isViewMode}
            name='ma_gd'
            className='w-full'
            type='select'
            options={transactionOptions}
          />
        </div>
      </div>
    </div>
  );
}
